import { createContext } from 'react';

import { Building } from '@totem/components/orgManagement/orgDetails/buildings/applied/types';

interface Context {
  buildings: Building[];
  onAction: (action: string, building: Building) => void;
  action: string;
  selectedBuilding: Building;
  onRefresh: () => void;
  onUpdateBuildingNetSuiteKey: (
    action: string,
    organizationId: string,
    buildingId: string,
    netSuiteKey: string,
  ) => void;
}

export default createContext<Context>({
  buildings: [],
  onAction: () => {},
  action: '',
  selectedBuilding: null,
  onRefresh: () => {},
  onUpdateBuildingNetSuiteKey: () => {},
});
